import React from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as IconArrowRight } from './icons/arrow_right.svg';
import styles from './Button.module.css';

const VARIANT_CLASS = {
  primary: 'variantPrimary',
  secondary: 'variantSecondary',
  'link-arrow': 'variantLinkArrow',
};

const isExternal = (href) => /^https?:\/\//i.test(href);

export default function Button({
  variant = 'primary',
  to,
  href,
  onClick,
  type = 'button',
  iconRight,
  className,
  children,
  ...rest
}) {
  const variantClass = styles[VARIANT_CLASS[variant]] || '';
  const composed = `${styles.btn} ${variantClass}${className ? ' ' + className : ''}`;

  const icon = iconRight !== undefined
    ? iconRight
    : (variant === 'link-arrow' ? <IconArrowRight aria-hidden="true" /> : null);

  const inner = (
    <>
      <span className={styles.label}>{children}</span>
      {icon && <span className={styles.iconRight}>{icon}</span>}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={composed} onClick={onClick} {...rest}>
        {inner}
      </Link>
    );
  }
  if (href) {
    const external = isExternal(href);
    return (
      <a
        href={href}
        className={composed}
        onClick={onClick}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
        {...rest}
      >
        {inner}
      </a>
    );
  }
  return (
    <button type={type} className={composed} onClick={onClick} {...rest}>
      {inner}
    </button>
  );
}
